import { React, useState, useEffect } from "react";
import { Form, Grid } from "semantic-ui-react";

import { isEmpty, map, find, subtract, get, isNaN } from "lodash";

import PropTypes from "prop-types";
import Joi from "joi";

// Components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";

// Styles
import styles from "./styles.module.css";

const AlertTimes = ({ tableValue, alertTimesHandler, onClose, data }) => {
	// hooks
	const [errors, setErrors] = useState([{ time: "" }]);
	const [limitMax, setLimitMax] = useState(9999);
	const [limitMin, setLimitMin] = useState(0);

	const [formData, setFormData] = useState({});

	// Effects

	useEffect(() => {
		if (tableValue) {
			let backwardness = {};
			let onTime = {};
			let defeated = {};

			switch (tableValue.name) {
				case "Vencido":
					backwardness = find(data, { name: "En Atraso" });
					setLimitMin(backwardness);

					setLimitMax({ name: "Maximo", time: 9999, color: "red" });
					break;
				case "En Atraso":
					onTime = find(data, { name: "A Tiempo" });
					defeated = find(data, { name: "Vencido" });
					setLimitMin(onTime);
					setLimitMax(defeated);
					break;
				case "A Tiempo":
					backwardness = find(data, { name: "En Atraso" });
					setLimitMin({ name: "Minimo", time: 0, color: "red" });
					setLimitMax(backwardness);
					break;

				default:
					return "";
			}

			setFormData(tableValue);
		}
	}, [tableValue]);

	const schema = Joi.object().keys({
		time: Joi.number()
			.min(subtract(get(limitMin, "time", 0), 1))
			.max(subtract(get(limitMax, "time", 9999), 1))
			.messages({
				"number.base": "Tiempo es un campo requerido",
				"number.min": `El numero tiene que ser mayor que  0  `,
				"number.max": `El numero tiene que ser menor que  9999`,
			}),
	});

	// input handlers
	const handleInput = (e, { name, value }) => {
		let validValue = parseInt(value, 10);
		if (isNaN(validValue)) validValue = 0;
		setFormData({
			...formData,
			[name]: validValue,
		});
	};

	// saveHandlers
	const save = () => {
		const validation = schema.validate({ time: formData.time }, { abortEarly: false });
		if (validation.error) {
			const { details } = validation.error;
			let errorss = {
				time: "",
			};
			map(details, (item) => {
				errorss = { ...errorss, [item.context.key]: item.message };
			});
			setErrors(errorss);
		} else {
			alertTimesHandler(formData);
			onClose();
		}
	};

	return (
		<IKModal title={`Alerta - ${tableValue.name}`} onClose={onClose} onSuccess={save} size="mini" iconName="edit">
			<div className={styles.grid}>
				<fieldset className={styles.fieldset}>
					<Form noValidate>
						<Grid columns={1}>
							<Grid.Column width={16} className={styles.column}>
								<Grid.Row className={styles.row}>
									<Form.Field className={styles.field} style={{ width: "100%" }}>
										<Input
											value={String(formData.time)}
											icon="clock"
											type="number"
											name="time"
											label="Tiempo en minutos"
											required
											fluid
											error={!isEmpty(errors.time) && { content: errors.time, pointing: "above" }}
											onChange={handleInput}
											className={styles.classTime}
										/>
									</Form.Field>
								</Grid.Row>
							</Grid.Column>
						</Grid>
					</Form>
				</fieldset>
			</div>
		</IKModal>
	);
};

AlertTimes.propTypes = {
	tableValue: PropTypes.object,
	alertTimesHandler: PropTypes.func,
	onClose: PropTypes.func,
	data: PropTypes.array,
};

export default AlertTimes;
